module.exports = __webpack_public_path__ + "img/Google-log.362a9ac6.png";